// extracted by mini-css-extract-plugin
module.exports = {"root":"sub-title_root__1PBgb","free":"sub-title_free__1YnT5"};